import React from 'react';

const CourseDetail = props => {
    const homeDicount= props.homeDicount ? (
      <div className="PlanDetailCourceAd">
        {'おうち割対象'}
      </div>
    ) : null;

    return (
      <div className="PlanDetailCource">
        <div className="PlanDetailCourceTitle">
          <div className="PlanDetailCourceTitleText" >
            {props.name}
          </div>
          {homeDicount}
        </div>
        <div className="PlanDetailCourcePrice" >
          <div className="PlanDetailCourcePrefix" >
            通常料金 /月
          </div>
          <div className="PlanDetailCourcePriceValue" >
            {`${props.price}円`}
          </div>
          <div className="PlanDetailCourcePrefix" >
            （税込 {`${props.priceWithTax}円`}）
          </div>
        </div>
      </div>
    );
  };

export default CourseDetail;
